module.exports = __webpack_public_path__ + "img/team1.b92cef9a.png";